import { render, staticRenderFns } from "./ProjectsAndExperiences.vue?vue&type=template&id=6a5e14bf&scoped=true&"
import script from "./ProjectsAndExperiences.vue?vue&type=script&lang=ts&"
export * from "./ProjectsAndExperiences.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsAndExperiences.vue?vue&type=style&index=0&id=6a5e14bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e14bf",
  null
  
)

export default component.exports